




import { Component, Vue } from "vue-property-decorator";
import {
  PaymentMethodType,
  SelectedPaymentPayLater
} from "@/models/selectPaymentMethod";

@Component
export default class PayLater extends Vue {
  public created() {
    this.$emit("input", {
      type: PaymentMethodType.PAY_LATER
    } as SelectedPaymentPayLater);
  }
}
